if (document.querySelector('html').classList.contains('themes')) {
	// Switch Modes ===========================================================
	if (localStorage.mode == 'dark') {
		loadDarkMode()
	} else if (localStorage.mode == 'light') {
		loadLightMode()
	} else {
		loadAutoMode()
	}

	window.addEventListener('load', function () {
		if (document.querySelector('.theme-switch .icon.dark')) {
			document.querySelector('.theme-switch .icon.dark').addEventListener('click', loadDarkMode)
		}
		if (document.querySelector('.theme-switch .icon.auto')) {
			document.querySelector('.theme-switch .icon.auto').addEventListener('click', loadAutoMode)
		}
		if (document.querySelector('.theme-switch .icon.light')) {
			document.querySelector('.theme-switch .icon.light').addEventListener('click', loadLightMode)
		}
		window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', refreshAutoMode)
		document.querySelector('html').style = 'display: block; opacity: 1'
	})

	function cleanModes() {
		if (document.querySelector('html').classList.contains('theme--light')) {
			document.querySelector('html').classList.remove('theme--light')
		}
		if (document.querySelector('html').classList.contains('theme--auto')) {
			document.querySelector('html').classList.remove('theme--auto')
		}
		if (document.querySelector('html').classList.contains('theme--dark')) {
			document.querySelector('html').classList.remove('theme--dark')
		}
	}

	function loadLightMode() {
		cleanModes()
		localStorage.mode = 'light'
		document.querySelector('html').classList.add('theme--light')
	}

	function loadDarkMode() {
		cleanModes()
		localStorage.mode = 'dark'
		document.querySelector('html').classList.add('theme--dark')
	}

	function loadAutoMode() {
		cleanModes()
		localStorage.mode = 'auto'
		document.querySelector('html').classList.add('theme--auto')
		refreshAutoMode()
	}

	function refreshAutoMode() {
		if (localStorage.mode == 'auto') {
			cleanModes()
			if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
				document.querySelector('html').classList.add('theme--dark')
			} else {
				document.querySelector('html').classList.add('theme--light')
			}
			document.querySelector('html').classList.add('theme--auto')
		}
	}
}
